import { RT_API_LIST } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  apiKey: '',
  configList: [],
  fetchApiKeyStatus: null,
  fetchApiKeyError: null,
  fetchConfigListStatus: null,
  fetchConfigListError: null,
  approveConfigStatus: null,
  approveConfigError: null,
  createConfigStatus: null,
  createConfigError: null,
  deleteConfigStatus: null,
  deleteConfigError: null,
  editConfigStatus: null,
  editConfigError: null,
  fetchModelsStatus: null,
  fetchModelsError: null,
  selectedConfigIds: [],
  gridState: {
    sortBy: [{ id: 'created', desc: true, find: () => {}, findIndex: () => {} }],
  },
  controlledGridState: {
    sortBy: [{ id: 'created', desc: true, find: () => {}, findIndex: () => {} }],
  },
  selectedGridRows: [],
  maxGridRowSelection: 1,
  models: [],
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RT_API_LIST.UNSET:
      return {
        ...state,
        [action.payload]: INITIAL_STATE[action.payload],
      };
    case RT_API_LIST.FETCH_CONFIG_LIST:
      return {
        ...state,
        fetchConfigListStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_LIST.FETCH_CONFIG_LIST_FAILURE:
      return {
        ...state,
        fetchConfigListError: action.payload,
        fetchConfigListStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_LIST.FETCH_CONFIG_LIST_SUCCEEDED:
      return {
        ...state,
        configList: action.payload,
        fetchConfigListStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_LIST.FETCH_API_KEY:
      return {
        ...state,
        fetchApiKeyStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_LIST.FETCH_API_KEY_FAILURE:
      return {
        ...state,
        fetchApiKeyError: action.payload,
        fetchApiKeyStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_LIST.FETCH_API_KEY_SUCCEEDED:
      return {
        ...state,
        apiKey: action.payload,
        fetchApiKeyStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_LIST.APPROVE_CONFIG:
      return {
        ...state,
        approveConfigStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_LIST.APPROVE_CONFIG_FAILURE:
      return {
        ...state,
        approveConfigError: action.payload,
        approveConfigStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_LIST.APPROVE_CONFIG_SUCCEEDED:
      return {
        ...state,
        approveConfigStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_LIST.CREATE_CONFIG:
      return {
        ...state,
        createConfigStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_LIST.CREATE_CONFIG_FAILURE:
      return {
        ...state,
        createConfigError: action.payload,
        createConfigStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_LIST.CREATE_CONFIG_SUCCEEDED:
      return {
        ...state,
        createConfigStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_LIST.DELETE_CONFIG:
      return {
        ...state,
        deleteConfigStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_LIST.DELETE_CONFIG_FAILURE:
      return {
        ...state,
        deleteConfigError: action.payload,
        deleteConfigStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_LIST.DELETE_CONFIG_SUCCEEDED:
      return {
        ...state,
        deleteConfigStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_LIST.EDIT_CONFIG:
      return {
        ...state,
        editConfigStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_LIST.EDIT_CONFIG_FAILURE:
      return {
        ...state,
        editConfigError: action.payload,
        editConfigStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_LIST.EDIT_CONFIG_SUCCEEDED:
      return {
        ...state,
        editConfigStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_LIST.SET_GRID_STATE:
      return {
        ...state,
        gridState: action.payload,
        controlledGridState: {},
      };
    case RT_API_LIST.SET_SELECTED_ROWS:
      return {
        ...state,
        selectedGridRows: action.payload,
        selectedConfigIds: action.payload.map(({ original: { id } }) => id),
        controlledGridState: {
          ...state.controlledGridState,
          selectedRowIds: Object.fromEntries(action.payload.map(({ id }) => [id, true])),
        },
      };
    case RT_API_LIST.DESELECT_ALL_ROWS:
      return {
        ...state,
        controlledGridState: {
          selectedRowIds: {},
        },
        selectedConfigIds: [],
        selectedGridRows: [],
      };
    case RT_API_LIST.FETCH_MODELS:
      return {
        ...state,
        fetchModelsStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_LIST.FETCH_MODELS_SUCCEEDED:
      return {
        ...state,
        models: action.payload,
        fetchModelsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_LIST.FETCH_MODELS_FAILED:
      return {
        ...state,
        fetchModelsStatus: CONSTANTS.API.FAILED,
      };
    default:
      return state;
  }
};
